import { render } from "./DynamicPlayerInterface.vue?vue&type=template&id=52e74750"
import script from "./DynamicPlayerInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicPlayerInterface.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/DynamicPlayerInterface.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52e74750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52e74750', __exports__)) {
    api.reload('52e74750', __exports__)
  }
  
  module.hot.accept("./DynamicPlayerInterface.vue?vue&type=template&id=52e74750", () => {
    api.rerender('52e74750', render)
  })

}


export default __exports__